import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import './warning.css'

function Warning({ warningText, handleConfirm, handleCancel, show }) {
    // EVENT HANDLERS
    const handleYes = () => {
        handleConfirm(false)
        handleCancel(false)
    }

    const handleNo = () => {
        handleConfirm(false)
    }

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            backdrop='static'
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Let op!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{warningText}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleNo}>Cancel</Button>
                <Button onClick={handleYes}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default Warning